import { render, staticRenderFns } from "./insurers-edit.vue?vue&type=template&id=7e54e6a1&scoped=true"
import script from "./insurers-edit.vue?vue&type=script&lang=js"
export * from "./insurers-edit.vue?vue&type=script&lang=js"
import style0 from "./insurers-edit.vue?vue&type=style&index=0&id=7e54e6a1&prod&lang=css"
import style1 from "./insurers-edit.vue?vue&type=style&index=1&id=7e54e6a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e54e6a1",
  null
  
)

export default component.exports